import React, { forwardRef, useImperativeHandle, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || "6LeutxksAAAAAHUdDdAIXtv85GWU1OQRDrJMORfQ";

type RecaptchaV2Props = {
  sitekey?: string;
  onChange?: (token: string | null) => void;
};

const RecaptchaV2 = forwardRef<any, RecaptchaV2Props>(({ sitekey, onChange }, ref) => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  useImperativeHandle(ref, () => ({
    execute: () => {
      if (recaptchaRef.current) {
        recaptchaRef.current.execute();
      }
    },
    reset: () => {
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
    }
  }));

  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      sitekey={sitekey || SITE_KEY}
      onChange={onChange}
      size="normal"
    />
  );
});

export default RecaptchaV2;
